<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <!-- <div style="max-width: 1440px; margin: 0 auto; min-width: 1220px;border: 1px solid #dbdbdb;"> -->
    <!-- <div> -->
    <!-- <p>Device ID: {{ deviceId }}</p>
      <p>User: {{ user }}</p> -->
    <!-- <button @click="loginSuccess">Send Login Success</button> -->
    <router-view />
    <!-- </div> -->
  </div>
</template>
<script>
import { webBridge } from "../utils/WebBridge.js";
export default {
  name: "App",
  data() {
    return {
      deviceId: null,
      user: null,
    };
  },
  mounted() {
    const deviceId =
      window.ClientDeviceId ||
      localStorage.getItem("deviceId") ||
      "UNKNOWN_DEVICE";

    this.deviceId = deviceId;
    localStorage.setItem("deviceId", deviceId);
    console.log("当前设备ID是：", deviceId);
  },
  methods: {
    loginSuccess() {
      webBridge.send("LoginSuccess", { user: "Tom", token: "abc123" });
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 16px;
}

/* 禁止所有水平滚动 */
html,
body {
  width: 100%;
  overflow-x: hidden;
  position: fixed;
}

#app {
  height: 100vh;
  /* min-height: 1040px; */
  width: 100vw;
  overflow: hidden;
  background: #e0f6e4;
}
/* 全局字体统一 */
* {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

/* 或者专门针对Element UI输入框 */
.el-textarea__inner,
.el-input__inner {
  font-family: inherit !important;
}
</style>
